import React from 'react';

interface Props {
    className?: string;
}

export const PanelIcon: React.FC<Props> = ({ className }) => {
    return (
        <svg
            className={`icon${className ? ` ${className}` : ''}`}
            width="70.727"
            height="58.436"
            viewBox="0 0 70.727 58.436"
        >
            <g id="Group_287" data-name="Group 287" transform="translate(-924.636 -2274.86)">
                <g id="Group_286" data-name="Group 286" transform="translate(924.636 2298.654)">
                    <g id="Group_40" data-name="Group 40" transform="translate(24.421 9.269)">
                        <g id="Group_39" data-name="Group 39" className="cls-2">
                            <path
                                id="Path_14"
                                data-name="Path 14"
                                className="cls-1"
                                d="M17.649,163.545H4.236A4.236,4.236,0,0,0,0,167.781v4.942H21.885v-4.942a4.236,4.236,0,0,0-4.236-4.236m2.651,7.593H1.584v-3.357a2.654,2.654,0,0,1,2.651-2.651H17.649a2.654,2.654,0,0,1,2.651,2.651Z"
                                transform="translate(0 -147.35)"
                            />
                            <path
                                id="Path_15"
                                data-name="Path 15"
                                className="cls-1"
                                d="M25.649,11.774h.574a1.148,1.148,0,0,0,1.108-.85,6.14,6.14,0,0,0,11.37,0,1.148,1.148,0,0,0,1.108.85h.574a1.149,1.149,0,0,0,1.149-1.149V6.783a1.149,1.149,0,0,0-1.149-1.149h-.545a6.948,6.948,0,0,0-13.645,0h-.545A1.149,1.149,0,0,0,24.5,6.783v3.842a1.149,1.149,0,0,0,1.149,1.149m7.367,1.386a4.555,4.555,0,1,1,4.555-4.555,4.56,4.56,0,0,1-4.555,4.555m0-11.37a5.161,5.161,0,0,1,4.5,2.637,6.136,6.136,0,0,0-9,0,5.161,5.161,0,0,1,4.5-2.637"
                                transform="translate(-22.074)"
                            />
                        </g>
                    </g>
                    <g id="Group_285" data-name="Group 285" transform="translate(0)">
                        <g id="Group_39-2" data-name="Group 39" className="cls-2">
                            <path
                                id="Path_14-2"
                                data-name="Path 14"
                                className="cls-1"
                                d="M17.649,163.545H4.236A4.236,4.236,0,0,0,0,167.781v4.942H21.885v-4.942a4.236,4.236,0,0,0-4.236-4.236m2.651,7.593H1.584v-3.357a2.654,2.654,0,0,1,2.651-2.651H17.649a2.654,2.654,0,0,1,2.651,2.651Z"
                                transform="translate(0 -147.35)"
                            />
                            <path
                                id="Path_15-2"
                                data-name="Path 15"
                                className="cls-1"
                                d="M25.649,11.774h.574a1.148,1.148,0,0,0,1.108-.85,6.14,6.14,0,0,0,11.37,0,1.148,1.148,0,0,0,1.108.85h.574a1.149,1.149,0,0,0,1.149-1.149V6.783a1.149,1.149,0,0,0-1.149-1.149h-.545a6.948,6.948,0,0,0-13.645,0h-.545A1.149,1.149,0,0,0,24.5,6.783v3.842a1.149,1.149,0,0,0,1.149,1.149m7.367,1.386a4.555,4.555,0,1,1,4.555-4.555,4.56,4.56,0,0,1-4.555,4.555m0-11.37a5.161,5.161,0,0,1,4.5,2.637,6.136,6.136,0,0,0-9,0,5.161,5.161,0,0,1,4.5-2.637"
                                transform="translate(-22.074)"
                            />
                        </g>
                    </g>
                    <g id="Group_284" data-name="Group 284" transform="translate(48.842)">
                        <g id="Group_39-3" data-name="Group 39" className="cls-2">
                            <path
                                id="Path_14-3"
                                data-name="Path 14"
                                className="cls-1"
                                d="M17.649,163.545H4.236A4.236,4.236,0,0,0,0,167.781v4.942H21.885v-4.942a4.236,4.236,0,0,0-4.236-4.236m2.651,7.593H1.584v-3.357a2.654,2.654,0,0,1,2.651-2.651H17.649a2.654,2.654,0,0,1,2.651,2.651Z"
                                transform="translate(0 -147.35)"
                            />
                            <path
                                id="Path_15-3"
                                data-name="Path 15"
                                className="cls-1"
                                d="M25.649,11.774h.574a1.148,1.148,0,0,0,1.108-.85,6.14,6.14,0,0,0,11.37,0,1.148,1.148,0,0,0,1.108.85h.574a1.149,1.149,0,0,0,1.149-1.149V6.783a1.149,1.149,0,0,0-1.149-1.149h-.545a6.948,6.948,0,0,0-13.645,0h-.545A1.149,1.149,0,0,0,24.5,6.783v3.842a1.149,1.149,0,0,0,1.149,1.149m7.367,1.386a4.555,4.555,0,1,1,4.555-4.555,4.56,4.56,0,0,1-4.555,4.555m0-11.37a5.161,5.161,0,0,1,4.5,2.637,6.136,6.136,0,0,0-9,0,5.161,5.161,0,0,1,4.5-2.637"
                                transform="translate(-22.074)"
                            />
                        </g>
                    </g>
                </g>
                <path
                    id="Path_181"
                    data-name="Path 181"
                    className="cls-1"
                    d="M264.334,7.5,251.581.141a1.316,1.316,0,0,0-1.187,0L237.641,7.5a1.316,1.316,0,0,0-.593,1.028V23.258a1.317,1.317,0,0,0,.593,1.028l12.753,7.363a1.316,1.316,0,0,0,1.187,0l12.753-7.363a1.317,1.317,0,0,0,.593-1.028V8.532a1.316,1.316,0,0,0-.593-1.028m-23.069,3.267a.924.924,0,0,1,.416-.721l8.891-5.139a.922.922,0,0,1,.832,0l4.024,2.323a.254.254,0,0,1,0,.481l-13.748,7.95c-.229.132-.416.024-.416-.24Zm19.446,10.26a.922.922,0,0,1-.416.72l-8.9,5.128a.924.924,0,0,1-.832,0l-4.027-2.325a.254.254,0,0,1,0-.481l8.894-5.143a.924.924,0,0,0,.416-.721V16.372c0-.264-.187-.372-.416-.24l-11.315,6.543a.922.922,0,0,1-.832,0l-1.6-.924a.923.923,0,0,1-.416-.721V19.188a.923.923,0,0,1,.416-.721l16.179-9.349a.923.923,0,0,1,.832,0l1.6.926a.923.923,0,0,1,.416.721Z"
                    transform="translate(709.012 2274.86)"
                />
            </g>
        </svg>
    );
};
